exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status-label[data-v-99bb8336] {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n.status-tip-icon[data-v-99bb8336] {\n\tmargin-right: 4px;\n\tcolor: #c0c4cc;\n\tcursor: pointer;\n}\n", ""]);

// exports
